'use client';

import { c as _c } from "react/compiler-runtime";
import { Indicator as RadioGroupIndicatorPrimitive, Item as RadioGroupItemPrimitive, Root as RadioGroupRootPrimitive } from '@radix-ui/react-radio-group';
import { Circle } from 'lucide-react';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';
import { cn } from '@/lib/utils';
type RadioGroupProperties = ComponentPropsWithoutRef<typeof RadioGroupRootPrimitive> & {
  ref?: Ref<ComponentRef<typeof RadioGroupRootPrimitive>>;
};
const RadioGroup = t0 => {
  const $ = _c(10);
  let className;
  let properties;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...properties
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = properties;
    $[3] = ref;
  } else {
    className = $[1];
    properties = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("grid gap-2", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== properties || $[7] !== ref || $[8] !== t1) {
    t2 = <RadioGroupRootPrimitive className={t1} {...properties} ref={ref} />;
    $[6] = properties;
    $[7] = ref;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
RadioGroup.displayName = RadioGroupRootPrimitive.displayName;
type RadioGroupItemProperties = ComponentPropsWithoutRef<typeof RadioGroupItemPrimitive> & {
  ref?: Ref<ComponentRef<typeof RadioGroupItemPrimitive>>;
};
const RadioGroupItem = t0 => {
  const $ = _c(11);
  let className;
  let properties;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...properties
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = properties;
    $[3] = ref;
  } else {
    className = $[1];
    properties = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("border-border text-primary focus:ring-ring aspect-square h-4 w-4 rounded-full border focus:outline-none focus:ring-2 focus:ring-offset-2", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <RadioGroupIndicatorPrimitive className="flex items-center justify-center"><Circle className="h-2.5 w-2.5 fill-current text-current" /></RadioGroupIndicatorPrimitive>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== properties || $[8] !== ref || $[9] !== t1) {
    t3 = <RadioGroupItemPrimitive ref={ref} data-slot="radio-group-item" className={t1} {...properties}>{t2}</RadioGroupItemPrimitive>;
    $[7] = properties;
    $[8] = ref;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
RadioGroupItem.displayName = RadioGroupItemPrimitive.displayName;
export { RadioGroup, RadioGroupItem };